import { v4 as uuidV4 } from 'uuid'

const OFFLINE_SENSOR_NICK = 'APM-Go!-Offline'

/**
 * Creates a new sensor request to be saved locally.
 *
 * @param data  request data
 */
const createRequest = (data: { key: string, [key: string]: any }) => ({
  url: `/api/v1/x_eco_apmsensor/${data.key}`,
  method: 'GET',
  payload: { edit: true },
  data,
})

/**
 * Locally persist current pairing model as corresponding sensor model.
 *
 * @param module  current module
 */
const persistSensor = async (module: Gaia.AppModule.Spec) => {
  const { requests } = module[G.ADAPTER][G.PERSISTENCE]
  const { pairing, sensor } = module[G.MODEL][G.CHILDREN]
  const data = pairing[G.DATA]

  const key = sensor[G.STATE][G.REF] || uuidV4()
  const value = { ...data, nick: OFFLINE_SENSOR_NICK }

  const request = createRequest({ key, value })

  await requests.put(request)

  return key
}

export {
  persistSensor,
}
